import { FaInfo, FaLocationDot } from "react-icons/fa6";
import { FiCheck, FiEdit3 } from "react-icons/fi";
import { useState } from "react";
import { OdcUpdateInfo, PopUpdateInfo } from "./update_info";
import { MasterDataStylingCard } from "../../../../../../../components/styling/MasterDataStylingCard";

const InfoItem = ({ label, value, isLink }) => (
    <div>
        <label className="text-[9px] font-bold text-slate-500 uppercase tracking-widest">
            {label}
        </label>
        <p
            className={`font-bold text-sm mt-0.5 ${isLink ? "text-cyan-400 underline cursor-pointer hover:text-cyan-300" : "text-slate-200"
                }`}
        >
            {value}
        </p>
    </div>
);

export const DetailInfoSectionOdc = ({ data, refreshData }) => {
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [openModalUpdateInfo, setOpenModalUpdateInfo] = useState(false);
    return (
        <>
            <div className="lg:col-span-1">
                <div className="p-5 rounded-2xl sticky top-6" style={MasterDataStylingCard}>
                    <div className="flex items-center justify-between mb-4 border-b pb-3" style={{ borderColor: "rgba(51,65,85,0.2)" }}>
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-lg" style={{ background: "rgba(239,68,68,0.1)" }}>
                                <FaInfo className="text-cyan-400" />
                            </div>
                            <h3 className="font-bold text-gray-200">Info ODC UTAMA</h3>
                        </div>
                        <button
                            type="button"
                            onClick={() => setOpenModalUpdateInfo(true)}
                            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all border 
                            ${loadingUpdate
                                    ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-400"
                                    : "bg-cyan-500/10 border-cyan-500/30 text-cyan-400 hover:bg-cyan-500/20"
                                }`

                            }
                        >
                            {loadingUpdate ? <FiCheck /> : <FiEdit3 />}
                            {loadingUpdate ? "Selesai" : "Edit Data"}
                        </button>
                    </div>

                    {/* Content */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 text-xs gap-3">
                        <InfoItem label="POP" value={data?.pop?.name ?? "-"} />
                        <InfoItem label="NAS" value={data?.nas?.name ?? "-"} />
                        <InfoItem label="OLT" value={data?.olt?.name ?? "-"} />
                        <InfoItem label="Nama Centarl ODC " value={data?.name} />
                    </div>
                    <InfoItem label="Deskripsi" value={data?.description ?? "-"} />
                </div>
            </div>

            {/* ===== Modal Update Info ===== */}
            <OdcUpdateInfo
                openModal={openModalUpdateInfo}
                setOpenModal={setOpenModalUpdateInfo}
                data={data}
                refreshData={refreshData}
            />
        </>
    );
}